<template>
  <div class="currency-amount d-flex align-items-center font-weight-bold" :style="globalStyles">
    <span :style="itemStyles">{{ symbol }}</span>
    &nbsp;
    <vue-odometer
      ref="odometer"
      animation="slide"
      theme="minimal"
      :value="amount"
      :format="odometerFormat"
    />
  </div>
</template>

<script>
import VueOdometer from 'v-odometer/src'

export default {
  name: 'CurrencyOdometer',
  components: { VueOdometer },
  props: {
    amount: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      default: 'white'
    },
    fontSize: {
      type: String,
      default: '36px'
    },
    currencyConfig: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    odometerHeight: 0
  }),
  computed: {
    symbol() {
      return this.currencyConfig.symbol || this.currencyConfig.code
    },
    globalStyles() {
      const { color, fontSize } = this
      return {
        fontSize
      }
    },
    itemStyles() {
      // This fixes the vertical alignment between the odometer and the spans
      return {
        height: `${this.odometerHeight - 1}px`
      }
    },
    odometerFormat() {
      switch (this.locale) {
        case 'fr':
          return '( ddd)'
        case 'it':
        case 'de':
          return '(.ddd)'
        default:
          return '(,ddd)'
      }
    }
  },
  mounted() {
    this.odometerHeight = this.$refs.odometer.$el.getBoundingClientRect().height
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  // These styles fix the number alignment issue where skinnier numbers are left aligned, leaving
  // weird visual gaps in the render of the value
  .odometer-value {
    text-align: center;
    &.odometer-first-value,
    &.odometer-last-value {
      width: 100%;
    }
  }
}
</style>
